export class Tercero {
    constructor(){
        this.departamento = "20";
        this.municipio = "20001";
    }
    public id:number;
    
    public tipoIdentificacion:string;
    public identificacion:string;
    public dv:string;
    
    public tipoVinculacion:string;
    
    public tipoPersona:string;
    public primerNombre:string;
    public segundoNombre:string;
    public primerApellido:string;
    public segundoApellido:string;
    public razonSocial:string;
    public nombreCompleto:string;
    
    public direccion:string;
    public telefono:string;
    public correoElectronico:string;
    public fechaNacimiento?:Date;
    
    public departamento:string;
    public municipio:string;
    public estructuraContrato:boolean;

    public estado: string;

    public unionTemporalConsorcio: boolean;
    public consorcioUnionTemporal: string;
    
    public ordenId: number;
    public ordenNombre: string;
}

export class TercerosConCantidadEstudiosPreviosAsignados extends Tercero {
    public cantidadEstudiosPreviosAsignados: number;
}